/**
 * @file downloadLanguages.ts
 *
 * @description Languages offered when downloading reports and transcripts.
 */
export const SUPPORTED_REPORT_DOWNLOAD_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "hi", label: "Hindi" },
  { code: "vi", label: "Vietnamese" },
] as const;

// Sentinel for "download the transcript in its original/native language",
// i.e. the language it was transcribed in. Selecting it skips translation and
// downloads the stored transcript as-is. Not a real ISO code, so it must never
// be sent to the translation backend.
export const NATIVE_DOWNLOAD_LANGUAGE = "native";

// Codes must match what the translation backend expects. Two non-obvious
// ones: Mandarin is "zh"/"zh-TW" (not "cmn"/"man") and Tagalog is "tl".
export const SUPPORTED_TRANSCRIPT_DOWNLOAD_LANGUAGES = [
  { code: NATIVE_DOWNLOAD_LANGUAGE, label: "Original Transcript" },
  { code: "en", label: "English" },
  { code: "es", label: "Spanish" },
  { code: "zh", label: "Mandarin (Simplified)" },
  { code: "zh-TW", label: "Mandarin (Traditional)" },
  { code: "fa", label: "Farsi" },
  { code: "it", label: "Italian" },
  { code: "fr", label: "French" },
  { code: "ru", label: "Russian" },
  { code: "pa", label: "Punjabi" },
  { code: "tl", label: "Tagalog" },
  { code: "vi", label: "Vietnamese" },
  { code: "ko", label: "Korean" },
  { code: "ar", label: "Arabic" },
] as const;

export const DEFAULT_DOWNLOAD_LANGUAGE = NATIVE_DOWNLOAD_LANGUAGE;
